module.exports = __webpack_public_path__ + "img/kong.b274c63d.png";